export const configAllExistingDeviceRoute = {
  loadChildren: () =>
    import('./config-all-existing-device.module').then(m => m.ConfigAllExistingDevicePageModule)
};
